import { FETCH_TREE_STRUCTURE_SUCCESS } from "../../constants/ActionTypes";

const initialSettings = {};

export default (state = initialSettings, action) => {
  switch (action.type) {
    case FETCH_TREE_STRUCTURE_SUCCESS: {
      return { ...state, index: action.payload };
    }

    default:
      return state;
  }
};
